import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '@fontsource-variable/inter';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

import { Quasar } from 'quasar';
import Socket from '@/plugins/socket';
import Sentry from '@/plugins/sentry';
import VeeValidate from '@/plugins/vee-validate';
import globalMixin from '@/mixins/globalMixin';
import sanitizer from '@/plugins/sanitizer';
import datadog from '@/plugins/datadog';

import 'quasar/src/css/index.sass';
import '@/styles/index.css';
import '@/styles/icons.css';
import '@/styles/quasar.scss';

// Register global components
const app = createApp(App);

app.mixin(globalMixin);

app.config.errorHandler = (error) => {
  if (error.name === 'ChunkLoadError') {
    window.location.reload();
  }
};

app.use(Quasar, {});
app.use(store);
app.use(router);
app.use(Socket);
app.use(Sentry);
app.use(VeeValidate);
app.use(sanitizer);
app.use(datadog);
app.mount('#app');
